import { memo } from "react";
import { StepTypeEditorProps } from "../types";

export const DefaultStepTypeSpecificProps = memo(
  (_props: StepTypeEditorProps) => null,
);
